import { useEffect, useRef } from "react";

export default function PlaneScroller({ children }) {
  const planeRef = useRef(null);
  const trailRef = useRef(null);
  const trackRef = useRef(null);

  useEffect(() => {
    const plane = planeRef.current;
    const trail = trailRef.current;
    const track = trackRef.current;

    let currentY = 0;
    let targetY = 0;

    // faster response (key fix)
    const ease = 0.18;

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const maxScroll =
        document.documentElement.scrollHeight - window.innerHeight;

      const percent = scrollTop / maxScroll;
      targetY = percent * track.clientHeight;
    };

    const animate = () => {
      // faster follow (removes “lag” feeling)
      currentY += (targetY - currentY) * ease;

      const rotation = (targetY - currentY) * 0.25;

      plane.style.transform = `
        translateY(${currentY}px)
        rotate(${rotation}deg)
      `;

      trail.style.height = `${currentY}px`;

      requestAnimationFrame(animate);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    animate();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {children}

      {/* TRACK */}
      <div
        ref={trackRef}
        style={{
          position: "fixed",
          right: "28px",
          top: "12%",
          height: "76%",
          width: "2px",
          background: "rgba(0,0,0,0.12)",
          borderRadius: "2px",
          zIndex: 9998
        }}
      >
        {/* TRAIL */}
        <div
          ref={trailRef}
          style={{
            position: "absolute",
            top: 0,
            width: "3px",
            background: "rgba(0,0,0,0.65)",
            borderRadius: "2px"
          }}
        />
      </div>

      {/* PLANE */}
      <div
        ref={planeRef}
        style={{
          position: "fixed",
          right: "16px",
          top: "12%",
          zIndex: 9999,
          willChange: "transform",
          filter: "drop-shadow(0 3px 6px rgba(0,0,0,0.35))"
        }}
      >
        {/* clearer, darker plane */}
        <svg width="54" height="54" viewBox="0 0 64 64">
          <path
            d="M2 34 L62 30 L62 26 L2 22 L2 26 L40 30 L2 34 Z
               M40 30 L52 48 L56 48 L48 30 Z
               M40 30 L52 12 L56 12 L48 30 Z"
            fill="#0a0a0a"
          />
        </svg>
      </div>
    </>
  );
}